export enum RFWebPermissaoEnum{
  // Menu Grupo
  rfpCadastroMenuGrupo = 1,
  rfpCadastroGrupo = 2,
  rfpCadastroGrupoRegiao = 3,

  // rfpCadastroGrupoPesquisa = 4, // não usado

  // Menu Player
  rfpCadastroMenuPlayer = 12,
  rfpCadastroPlayer = 13,
  rfpCadastroPlayerRamoAtividade = 62,

  rfpConsultalPlayerMenu = 14,
  rfpConsultalPlayerDeletado = 15,
  rfpConsultalPlayerMaisOuvidas = 16,
  // rfpCadastroPlayerPesquisa = 14, // não usado

  // Menu Coletanea
  rfpCadastroMenuColetanea = 22,
  rfpCadastroColetanea = 23,
  rfpCadastroGrupoColetanea = 63,
  // rfpCadastroColetaneaPesquisa = 25, // não usado

  // Menu Spot
  rfpCadastroMenuSpot = 31,
  rfpCadastroSpot = 32,
  rfpCadastroSpotAgendamento = 60,

  rfpConsultaSpotMenu = 33,
  rfpConsultaSpotMaisOuvido = 34,
  // rfpCadastroMenuSpotPesquisa = 33,// não usado

  // Menu Anuncios
  rfpCadastroMenuAnuncios = 35,
  rfpCadastroAnuncios = 36,
  rfpCadastroAnunciosParametros = 65,
  // rfpCadastroAnunciosPesquisa = 37,

  // Menu Administrativo
  rfpAdministrativoMenuAdministrativo = 39,
  rfpAdministrativoAdminUser = 40,
  rfpAdministrativoVersion = 41,
  rfpAdministrativoAndroidVersion = 66,
  rfpAdministrativoEmail = 64,

  rfpCadastroUsuarioGrupoPlayer = 44,

  rfpCadastroUsuarioPlayer = 52,
  rfpCadastroUsuarioPlayerContato = 53,
  rfpCadastroUsuarioPlayerColetanea = 54,
  rfpCadastroUsuarioPlayerMusicas = 55,
  rfpCadastroUsuarioPlayerAtividades = 56,

}
